<template>
  <div class="wrapper">
    <p class="title mb-3">快递公司<span class="content">{{ shippingProviderName }}</span></p>
    <p class="title mb-3">快递单号<span class="content">{{ shippingNumber }}</span></p>
    <hr class="mb-3">
    <div v-if="tracking.length>0" class="delivery">
      <div v-for="(item,i) in tracking" :key="i" class="delivery-item">
        <span class="dot first"></span>
        <span class="date">{{ genDate(item.acceptTime) }}</span>
        <span class="detail">{{ item.remark }}</span>
      </div>
    </div>
    <div v-else>
      <p class="mb-3">暂未查到与您单号相关的物流信息，请稍候再尝试查询，有可能是</p>
      <p class="title">1.快递单号不存在</p>
      <p class="title">2.快递尚未收取该快件</p>
      <p class="title">3.手机号填写错误</p>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {dateFormat} from "vue-filter-date-format";

  export default {
    name: "Delivery",
    computed: {
      ...mapGetters(['tracking']),
      id() {
        return this.$route.query.id;
      },
      shippingNumber() {
        return this.$route.query.shippingNumber;
      },
      shippingProviderName() {
        return decodeURI(this.$route.query.shippingProviderName);
      },
    },
    methods: {
      ...mapActions(['getTracking']),
      genDate(date) {
        return dateFormat(new Date(date + ''), "YYYY-MM-DD HH:mm");
      },
    },
    created() {
      window.document.title = '物流信息';
      this.getTracking(this.id);
    }
  }
</script>

<style scoped>
  .title {
    color: #999;
  }

  .content {
    color: #000;
    padding-left: 20px;
  }

  hr {
    border: 1px solid #EEEEEE;
    border-top: none;
  }

  .delivery {
    border-left: 1px dashed #707070;
    margin-left: 10px;
  }

  .delivery-item {
    display: flex;
    align-items: center;
    transform: translateX(-6px);
    font-size: 12px;
    margin-bottom: 10px;
  }

  .delivery-item .dot {
    width: 12px;
    height: 12px;
    background: #fff;
    border-radius: 50%;
    display: block;
    position: relative;
    margin-right: 5px;
    flex: 0 0 auto;
    border: 1px solid #ccc;
  }

  .delivery-item .dot.first {
    background: #3579FF;
    border: 1px solid #3579FF;
  }

  .delivery-item .dot::before {
    position: absolute;
    top: 3px;
    left: 2px;
    width: 3px;
    height: 3px;
    content: '';
    border-top: 2px #707070 solid;
    border-left: 2px #707070 solid;
    transform: rotate(45deg);
  }

  .delivery-item .dot.first::before {
    border-top: 2px #fff solid;
    border-left: 2px #fff solid;
  }

  .delivery-item .date {
    flex: 0 0 auto;
    margin-right: 10px;
    color: #999;
    width: 105px;
  }

  .delivery-item .detail {
    flex: 1 1 auto;
  }
</style>